import { cn } from "@/modules/lib/utils"
import errorNoRepLight from "@images/error/errorNoRepLight.svg"
import { word } from "@modules/core/utils/i18n"
import { Text } from "@/components/ui/baseUi/text"

export function ErrorView({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("flex h-120 min-h-full w-full flex-col items-center justify-center gap-2", className)}
      {...props}
    >
      <Text fontStyle="BM" className="text-textDefault-heading">
        {word("global.error.norep")}
      </Text>
      <img src={errorNoRepLight} />
      <Text fontStyle="BM" className="text-textDefault-caption">
        {word("global.error.somethingGoneWrong")}
      </Text>
    </div>
  )
}
